import { TFunction } from "i18next";
import { AssetStatus } from "utils/constants/assets.constants";
import {
  DocumentComponentStatus,
  DocumentStatus,
} from "utils/constants/doc.constants";
import { HAQStatus } from "utils/constants/HAQ.constants";
import { ProjectStatus } from "utils/constants/project.constants";
import { EMPTY_LABEL } from "../getTextValue";

export type TPossibleAssetStatus =
  | AssetStatus
  | DocumentStatus
  | HAQStatus
  | DocumentComponentStatus;

export const getDisplayedAssetStatus = (
  status: TPossibleAssetStatus | undefined,
  t: TFunction,
) => {
  return status
    ? t(`status.asset.${status}`, { ns: "common", defaultValue: "" })
    : EMPTY_LABEL;
};

export const getDisplayedProjectStatus = (
  status: ProjectStatus | undefined,
  t: TFunction,
) => {
  return status ? t(`status.project.${status}`, { ns: "common" }) : EMPTY_LABEL;
};
